
import useJwt from '@/auth/jwt/useJwt'

const HOME_ROUTES = Object.freeze({
  Admin: '/',
  Management: '/',
  SuperAdmin: '/',
  SiteSupport: '/apps/cache-system',
  Support: '/apps/users/list',
  PageAdmin: '/',
  Designer: '/apps/home-slides',
  Blogger: '/pages/blog/list',
  ProductManager: '/apps/e-commerce/shop',
  PhoneSupport: '/apps/chats',
  Accountent: '/apps/financial/wallets/list'
})

export const getUserData = () => {
  try {
    const storedData = localStorage.getItem('userData')

    if (!storedData) {
      return null
    }

    return JSON.parse(storedData)
  } catch (error) {
    return null
  }
}

export const isUserLoggedIn = () => {
  const userData = getUserData()
  const tokenKey = useJwt.jwtConfig.storageTokenKeyName
  const token = localStorage.getItem(tokenKey)

  return Boolean(userData && userData.user && token)
}

export const getUserRole = () => {
  const userData = getUserData()

  if (!userData || !userData.user) {
    return null
  }

  return userData.user.role || null
}

export const getHomeRouteForLoggedInUser = userRole => {
  if (!userRole || typeof userRole !== 'string') {
    return null
  }

  const role = userRole.trim()

  if (!Object.prototype.hasOwnProperty.call(HOME_ROUTES, role)) {
    return null
  }

  return HOME_ROUTES[role]
}
